module.exports = __webpack_public_path__ + "img/ios-color-palette.b2ce1b89.svg";